export class CompanyAccountUrl {
    // GET
    public static get GET_COUNTRY_LIST(): string { return '/api/Organization/GetCountryHasOrganization'; }
    public static get GET_DISCOUNT_LIST(): string { return '/api/Organization/GetDiscount'; }
    public static get GET_COMPANY_ACCOUNT_LIST(): string { return '/api/Organization/GetOrganization'; }
    public static get GET_COMPANY_ACCOUNT(): string { return '/api/Organization/GetById'; }
    public static get GET_COMPANY_ACCOUNT_INIT(): string { return '/api/Organization/organizationRegister'; }

    public static get GET_ALL_COMPANY(): string { return '/api/Organization'; }
    public static get ADD_COMPANY_ACCOUNT(): string { return '/api/Organization'; }
    public static get UPDATE_COMPANY_ACCOUNT(): string { return '/api/Organization'; }
    public static get CHECK_ORG_CODE(): string { return '/api/Organization/GetOrgCode'; }
}



// WEBPACK FOOTER //
// D:/TMB/TMB/MYTMB.UI/src/app/shared/urls/company-account.url.ts